import styled from 'styled-components'
import { Button } from 'antd'

export const ButtonEx = styled(Button)`
  ${(props) =>
    props.color &&
    `
      background-color: ${props.color} !important;
      border-color: ${props.color} !important;
    `}
`



// WEBPACK FOOTER //
// ./src/styles/button.style.js